import React, { ContextType, createContext, Fragment, ReactNode } from 'react';
import { common } from '@kurtosys/ksys-app-template';
import { appsManager } from '@kurtosys/ksys-app-template';
import { CacheOptions, IApplicationAssetRegister } from '@kurtosys/types/appsInitialize/index.js';
import { observer } from 'mobx-react';

import { assets as defaultAssets } from '../../../assets/assets.js';
import { IAssets } from '../../../models/IAssets.js';
import { ComponentBase } from '../../../shared/index.js';

import { IAssetContextValue } from './models/IAssetContextValue.js';
import { IAssetConfiguration, IAssetProps, IAssetState } from './models/index.js';
import { ASSET_CATEGORY_KEY, ASSET_COMPONENT_KEY } from './Asset.meta.js';

const appendCacheQueryStringRaw = appsManager.utils.appendCacheQueryString;

// eslint-disable-next-line @typescript-eslint/naming-convention
export const AssetContextValue = (
	assets: IAssets = {},
	assetRegisters: IApplicationAssetRegister[] = [],
	cacheOptions?: CacheOptions,
) => {
	const assetRegisterByFileName = common.commonUtils.pivotCollection(
		assetRegisters,
		(assetRegister) => assetRegister.fileName,
	);
	const appendCacheQueryString = (fileName: string): string => {
		const assetRegister = assetRegisterByFileName[fileName];
		fileName = appendCacheQueryStringRaw(fileName, assetRegister, cacheOptions);
		return fileName;
	};
	const getAsset = (key: string): string => {
		const asset = common.commonUtils.get(assets, key);
		const response = appendCacheQueryString(asset || key);
		return response;
	};
	const hasAsset = (key: string): boolean => {
		const asset = common.commonUtils.get(assets, key, null);
		return !common.commonUtils.isNullOrEmpty(asset);
	};
	const baseUrl = (): string => {
		return (assets && assets.baseUrl) || '';
	};

	return {
		assets,
		getAsset,
		hasAsset,
		baseUrl,
		appendCacheQueryString,
	};
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export const AssetContext = createContext<IAssetContextValue>(AssetContextValue(defaultAssets));

export class Asset extends ComponentBase<IAssetProps, IAssetState, IAssetConfiguration> {
	categoryKey = ASSET_CATEGORY_KEY;
	componentKey = ASSET_COMPONENT_KEY;

	static contextType = AssetContext;
	context: ContextType<typeof AssetContext> | null = null;
	get asset(): ReactNode {
		const { children } = this.props;
		if (typeof children !== 'string' || !this.context || !this.context.assets) {
			return children;
		}
		return this.context.getAsset(children);
	}
	render() {
		return <Fragment>{this.asset}</Fragment>;
	}
}

export default observer(Asset);
